import { useState, useEffect } from 'react';
import { publicEventService } from '../services/publicEventService';

// Carrega os 3 grupos de eventos da Home pública.
// Não expõe detalhes do Firestore para os componentes.
export function usePublicEvents() {
  const [today,    setToday]    = useState([]);
  const [featured, setFeatured] = useState([]);
  const [upcoming, setUpcoming] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [error,    setError]    = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setLoading(true);
        setError(null);
        const data = await publicEventService.getHomeEvents();
        if (!cancelled) {
          setToday(data.today);
          setFeatured(data.featured);
          setUpcoming(data.upcoming);
        }
      } catch (err) {
        if (!cancelled) {
          console.error('usePublicEvents:', err);
          setError('Não foi possível carregar os eventos.');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    load();
    return () => { cancelled = true; };
  }, []);

  return { today, featured, upcoming, loading, error };
}
